import angular from 'angular';
import {
  loaderService,
  ssDialogService,
  controlDataService,
} from 'app/services';
import {
  alerts,
  confirmDialog,
} from 'app/components/global';
import controller from './sync-controlType-dialog.controller';
import template from './sync-controlType-dialog.html';
import control from '../control';
import syncControlConfirmDialog from '../dialog.syncControlConfirmDialog';


class dialogService {
  getOptions($event, {
    // eslint-disable-next-line no-shadow
    controlType,
    risk,
  }) {
    return {
      controller,
      controllerAs: 'syncControlTypeVM',
      locals: {
        controlType,
        risk
      },
      escapeToClose: false,
      clickOutsideToClose: false,
      targetEvent: $event,
      template,
    };
  }
}

export default angular.module('app.components.admin.control.syncControlsDialog', [
  loaderService,
  alerts,
  confirmDialog,
  ssDialogService,
  controlDataService,
  control,
  syncControlConfirmDialog
])
  .service('syncControlTypeDialog', dialogService)
  .name;
